/** Classes partilhadas pelos separadores do painel Dados do IFC. */

export const BTN =
  'inline-flex items-center gap-1 rounded border border-[var(--color-border)] px-2 py-1 text-[11px] text-[var(--color-text-muted)] hover:text-[var(--color-text)] disabled:opacity-40'
export const BTN_PRIMARIO =
  'inline-flex items-center gap-1 rounded bg-[var(--color-accent)] px-2.5 py-1 text-[11px] font-medium text-[var(--color-bg)] hover:opacity-90 disabled:opacity-40'
export const INPUT =
  'w-full rounded border border-[var(--color-border)] bg-[var(--color-bg)] px-2 py-1 text-[11px] text-[var(--color-text)] outline-none focus:border-[var(--color-accent)]'
export const ROTULO = 'text-[10px] uppercase tracking-wider text-[var(--color-text-muted)]'
export const AVISO =
  'rounded border border-[var(--color-warn-border)] bg-[var(--color-warn-bg)] px-2 py-1 text-[10px] text-[var(--color-warn-text)]'
export const ERRO =
  'rounded border border-[var(--color-error-border)] bg-[var(--color-error-bg)] px-2 py-1 text-[10px] text-[var(--color-error-text)]'
export const OK =
  'rounded border border-[var(--color-ok-border)] bg-[var(--color-ok-bg)] px-2 py-1 text-[10px] text-[var(--color-ok-text)]'
export const NOTA = 'text-[10px] leading-snug text-[var(--color-text-dim)]'
